import { useContext, useEffect, useState } from 'react';

import { Context } from 'components/hoc/Store';

import useProfily from 'hooks/useProfily';

import { FsluzbaPutApi, IFSluzbyPutData } from 'services/statniSprava/FSluzbaPut';
import { IStatniSpravaPutResp, odeslaniFsluzbyApi } from 'services/statniSprava/odeslaniSluzby';
import { zalozeniFsluzbyApi } from 'services/statniSprava/zalozeni';

import { EUpozorneni } from 'enums/statniSprava/upozorneni';

export const useFormBasics = () => {
    const { profily, mePozadavkyBisign } = useContext(Context);
    const { setLevel } = useProfily();
    const sluzba = window.location.hash.split('/')[4] as keyof IFSluzbyPutData;
    const [errMsg, setErrMsg] = useState<string>();
    const [currentStep, setCurrentStep] = useState<number>(mePozadavkyBisign?.requestoid ? 2 : 0);
    const [idSluzby, setIdSluzby] = useState<number | undefined>(mePozadavkyBisign?.requestoid);
    const [upozorneni, setUpozorneni] = useState<EUpozorneni[] | undefined>(mePozadavkyBisign?.upozor?.map(e => e.typ));
    const [loading, setLoading] = useState<boolean>(false);
    const [odeslaniResp, setOdeslaniResp] = useState<IStatniSpravaPutResp>();

    useEffect(() => {
        return () => setLevel('mePozadavkyBisign', null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const next = () => {
        setCurrentStep(currentStep + 1);
        window.scrollTo(0, 0);
    };

    const prev = () => {
        setCurrentStep(currentStep - 1);
    };

    const showPxKlicLoadingMsg = currentStep === 1 && profily?.typprihlaseni === 'PXKLIC';

    const onFormSubmit = (dataToSend: IFSluzbyPutData[keyof IFSluzbyPutData]) => {
        // odstrani prazdne values (robilo problem na BE)
        const DataWithoutEmptyVals = Object.fromEntries(
            Object.entries(dataToSend).filter(([, v]) => v !== undefined && v !== '')
        ) as IFSluzbyPutData[keyof IFSluzbyPutData];
        if (currentStep === 0) {
            setLoading(true);
            !idSluzby
                ? zalozeniFsluzbyApi(sluzba)
                      .then(resp => {
                          setIdSluzby(resp.id);
                          FsluzbaPutApi(sluzba, resp.id, DataWithoutEmptyVals)
                              .then(data => {
                                  next();
                                  setUpozorneni(data.upozor.map(e => e.typ));
                              })
                              .catch(err => err.response.status === 401 && setErrMsg('DUVERNE_INF_ERR_401'))
                              .finally(() => setLoading(false));
                      })
                      .catch(() => setLoading(false))
                : FsluzbaPutApi(sluzba, idSluzby, DataWithoutEmptyVals)
                      .then(data => {
                          next();
                          setUpozorneni(data.upozor.map(e => e.typ));
                      })
                      .catch(err => err.response.status === 401 && setErrMsg('DUVERNE_INF_ERR_401'))
                      .finally(() => setLoading(false));
        } else if (currentStep === 1 && idSluzby) {
            setLoading(true);
            odeslaniFsluzbyApi(
                idSluzby,
                profily?.typprihlaseni === 'CERT' ? 'CERT' : profily?.typprihlaseni === 'BI' ? 'BI' : 'PW'
            )
                .then(data => {
                    data.redirect && window.location.replace(data.redirect);
                    setUpozorneni(data.upozor.map(e => e.typ));
                    setOdeslaniResp(data);
                    next();
                })
                .catch(err => err.response.status === 401 && setErrMsg('DUVERNE_INF_ERR_401'))
                .finally(() => setLoading(false));
        }
    };

    return [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] as const;
};
